// extracted by mini-css-extract-plugin
export default {"form":"Map-Team_form__G6M7D","formFooter":"Map-Team_formFooter__i1oTW"};